import { Module } from 'vuex';
import { actions } from '@/store/filters-simulation/actions';
import { getters } from '@/store/filters-simulation/getters';
import { mutations } from '@/store/filters-simulation/mutations';
import { state } from '@/store/filters-simulation/state';
import { RootState } from '@/models/states/root-state.model';
import { FiltersSimulationState } from '@/models/states/filters-state.model';

const namespaced: boolean = true;

export const filtersSimulation: Module<FiltersSimulationState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
